export default "__VITE_ASSET__wd4zDiQ1__"